class DailyTimer extends HTMLElement {
  constructor(){
    super();
  }

  connectedCallback(){
    this.CalculateTimer(); 
  }

  async getNextMidnight() {
    const now = new Date();
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
    return midnight.getTime();
  }

  async CalculateTimer(){
    const countdownTarget = await this.getNextMidnight();
    const countdownEl = this.querySelector("#countdown_span");

    const countdownInterval = setInterval(() => {
      const now = new Date().getTime();
      const distance = countdownTarget - now;

      if (distance < 0) {
          clearInterval(countdownInterval);
          countdownEl.innerHTML = "Offerta terminata!";
          return;
      }

      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      countdownEl.innerHTML = `${hours} ${window.translationHours} ${minutes} ${window.translationMinutes} ${seconds} ${window.translationSeconds}`;
    }, 1000);
  }
}

customElements.define('daily-timer', DailyTimer);
